/**
 * Shared iOS detection.
 *
 * iOS Safari (and iOS WebViews — all iOS browsers use WebKit) suspends the
 * page's AudioContext on screen lock / backgrounding, and — critically — a
 * MediaElementSourceNode's underlying <audio> stops producing sound while
 * its AudioContext is suspended, even though the element itself reports
 * `paused: false`. Any audio that must survive a locked screen on iOS has
 * to play UNROUTED (no Web Audio graph): the native background-audio path.
 *
 * Used by meditation-audio.ts (Lisa's voice) and brass-astrolabe.ts (the
 * ambient bed) so both make the same call from the same evidence.
 */
export const isIOS = (): boolean => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  const platform = navigator.platform;
  // Standard iOS detection: iPhone/iPad/iPod UA, or iPadOS 13+ which
  // reports as "MacIntel" but exposes touch support (real Macs don't).
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};
